/* eslint-disable react/no-unescaped-entities */
import Link from 'next/link';
import React from 'react';
import Statistic_promo_carousel from '../carousel/statistic_promo_2_carousel';

const Statistic_promo_3 = () => {
	return (
		<div>
			{/* <!-- Promo 3 --> */}
			<section className="statistic_promo_2-section bg-[#010107] py-12 lg:pb-32 overflow-x-hidden">
				{/* <!-- Promo 3 --> */}
				<div className="container pt-32">
					<div className="items-center justify-between lg:flex">
						<div className="relative text-center lg:w-1/2">
							
							<img
								src="/images/pelgine_gimp.png"
								alt=""
								loading="lazy"
								className="relative -top-10 inline-block"
								style={{ transform: 'scale(1.25)' }}
							/>
						
						</div>
						<div className="lg:w-[45%] lg:pl-16">
							<h2 className="mb-6 font-display text-2xl text-white">
							Integrate into your favorite art software
							</h2>
							<p className="mb-8 text-lg leading-normal text-jacarta-200">
							Pelgine will integrate with a growing list of tools - starting with Gimp
							</p>
							
						</div>
					</div>
					
				</div>
			</section>
			{/* <!-- end promo 3 --> */}
		</div>
	);
};

export default Statistic_promo_3;
